import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'How it Works', path: '/how-it-works' },
    { name: 'Services', path: '/services' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Insurance & Medicaid', path: '/insurance' },
    { name: 'FAQ', path: '/faq' },
    { name: 'About', path: '/about' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_26db3989-351b-4ced-8734-bc1c3085c5e6/artifacts/5iwgquk9_ChatGPT%20Image%20TouchscreenMD%20Original%20Logo%20Telehealth.png" 
              alt="TouchScreenMD" 
              className="h-16 w-auto transition-transform duration-300 group-hover:scale-105"
            />
            <div className="hidden lg:flex flex-col">
              <div className="text-xl font-bold tracking-tight leading-tight">
                <span className="text-[#4A5568]">TouchScreen</span>
                <span className="text-[#2D3E50]">MD</span>
                <span className="text-[#6B9FD8]">.com</span>
              </div>
              <div className="text-xs text-[#718096] font-medium leading-tight">
                Revolutionizing Healthcare. Quality Healthcare Anytime, Anywhere
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  isActive(link.path)
                    ? 'text-[#6B9FD8] bg-[#EFF6FB]'
                    : 'text-[#4A5568] hover:text-[#6B9FD8] hover:bg-[#EFF6FB]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-3">
            <Button
              variant="outline"
              className="border-2 border-[#6B9FD8] text-[#6B9FD8] hover:bg-[#6B9FD8] hover:text-white transition-all duration-200"
            >
              Sign In
            </Button>
            <Button
              className="bg-gradient-to-r from-[#6B9FD8] to-[#D4A5C2] hover:from-[#5A8BC7] hover:to-[#C394B1] text-white transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Start a Visit
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg text-[#4A5568] hover:bg-[#F0F5FF] transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-[#6B9FD8] bg-[#EFF6FB]'
                    : 'text-[#4A5568] hover:bg-[#EFF6FB]'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 space-y-2">
              <Button
                variant="outline"
                className="w-full border-2 border-[#6B9FD8] text-[#6B9FD8] hover:bg-[#6B9FD8] hover:text-white"
              >
                Sign In
              </Button>
              <Button className="w-full bg-gradient-to-r from-[#6B9FD8] to-[#D4A5C2] hover:from-[#5A8BC7] hover:to-[#C394B1] text-white">
                Start a Visit
              </Button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
